import { gql } from '@apollo/client'
import React from 'react'

import { compliancesClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useOpenNonCompliancesState = () => React.useContext(Context)
export const useOpenNonCompliances = () => useOpenNonCompliancesState()?.nonCompliances || []

// Self-contained on purpose: unlike `nonComplianceV2/placeList/nonCompliances/table`'s
// loader, this one isn't nested inside a `FilterHandler` (this tab lives inside the
// availability details modal, not a filterable list page), so it can't rely on
// `useCleanFilterForRequest`/`useSearch` from `@btime/react-contexts`.
const QUERY = gql`
  query AvailabilityOpenNonCompliances($filter: NonComplianceFilter) {
    nonCompliances(filter: $filter, sort: { field: UPDATED_AT, type: DESC }) {
      id
      place {
        id
        name
      }
      question {
        id
        name
        checklist {
          id
          name
        }
        category {
          id
          name
        }
      }
      instancesCount
      status
      insertedAt
      updatedAt
    }
  }
`

const OpenNonCompliancesLoader = ({ children, placeId }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { placeIds: [placeId], statuses: ['open'] } },
    client: compliancesClient,
    skip: !placeId
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default OpenNonCompliancesLoader
